import Vue from "vue"
import Dialog from "./dialog"
import Alert from "./alert"
import Confirm from "./confirm"
import Prompt from "./prompt"

const AlertComponent = Vue.extend(Alert)
const ConfirmComponent = Vue.extend(Confirm)
const PromptComponent = Vue.extend(Prompt)

const instances = []

const buildDialog = (Component, options) => {
  if (typeof options === "string") {
    options = {
      message: options,
    }
  }
  return new Promise((resolve, reject) => {
    const destroyWith = (handle) => (...args) => {
      handle(...args)
      setTimeout(() => {
        instance.$destroy()
      }, 200)
    }

    const instance = new Component({
      propsData: {
        visible: true,
        onCancel: destroyWith(reject),
        onConfirm: destroyWith(resolve),
        ...options,
      },
    }).$mount()

    instance.id = options.id || Math.random().toString()
    instances.push(instance)
  })
}

Dialog.alert = buildDialog.bind(null, AlertComponent)
Dialog.confirm = buildDialog.bind(null, ConfirmComponent)
Dialog.prompt = buildDialog.bind(null, PromptComponent)

Dialog.close = function(id) {
  const instance = instances.find(item => item.id === id)
  if (instance) {
    instance.visible = false
    instance.$destroy()
  }
}
Dialog.closeAll = function() {
  instances.forEach(item => {
    item.visible = false
    item.$destroy()
  })
}

Dialog.Alert = Alert
Dialog.Confirm = Confirm
Dialog.Prompt = Prompt

export default Dialog
